import React from "react";
import "../../../styles/lms/lms-global.scss";
import { GlobalConstants } from "../../constants/GlobalConstants";

interface IBCValidationMessage {
  error?: any;
  label?: string;
  hideErrorMessage?: boolean;
}

const LmsValidationMessage = ({ ...props }: IBCValidationMessage) => {
  const label = props.label ? `${props.label} ` : "";
  const message = props.error?.message ? props.error.message : GlobalConstants.ValidationMessages.REQUIRED;

  return <div className="lms-validation-message">
    {(props.error && !props.hideErrorMessage) && <React.Fragment>
      {label ? `${label}${props.error.message}.` : message[0]?.toLocaleUpperCase() + message.substring(1) + "."}
    </React.Fragment>}
  </div>;
};

export default LmsValidationMessage;